<template>
  <div>
    <b-modal v-model="showModal" hide-header hide-footer centered size="xl">
      <div class="d-flex justify-content-between align-items-center">
        <h3 class="font-weight-bold mb-0">
          รายการโค้ดส่วนลด <span v-if="prefix" class="prefix">( Prefix : {{ prefix }} )</span>
        </h3>
        <button type="button" aria-label="Close" class="close" @click="hide">
          ×
        </button>
      </div>
      <div class="d-flex justify-content-end mt-2" v-if="couponId">
        <b-button class="btn-main mr-2" @click="exportFile">Export</b-button>
        <b-button class="btn-main" @click="exportExcel">Export Data</b-button>
      </div>
      <div class="mt-3">
        <b-table
          class="table-list"
          striped
          responsive
          :items="items"
          :fields="fields"
          :busy="isBusy"
          :per-page="filter.perPage"
          :current-page="filter.pageNo"
          show-empty
          empty-text="ไม่พบข้อมูล"
        >
          <template #cell(status)="data">
            <div :class="resloveStatusColor(data.item.status)">
              {{ resloveStatusText(data.item.status) }}
            </div>
          </template>
          <template #cell(createDate)="data">
            <span v-if="data.item.createDate">{{
              new Date(data.item.createDate) | moment($formatDateTime)
            }}</span>
            <span v-else>-</span>
          </template>
          <template #cell(action)="data">
            <div
              v-if="couponId && data.item.status != 4"
              class="text-dark btn btn-link"
              @click="openModalCancel(data.item.code)"
            >
              ยกเลิก
            </div>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-black my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong class="ml-2">Loading...</strong>
            </div>
          </template></b-table
        >
        <div
          class="form-inline d-flex justify-content-between align-items-center"
        >
          <b-pagination
            v-model="filter.pageNo"
            :total-rows="rows"
            :per-page="filter.perPage"
            class="m-md-0"
            @change="pagination"
            align="center"
          ></b-pagination>
          <!-- <b-form-select
            class="mr-sm-3"
            v-model="filter.perPage"
            @change="hanndleChangePerpage"
            :options="pageOptions"
          ></b-form-select> -->
        </div>
      </div>
    </b-modal>
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalAlert ref="modalAlert" :text="modalMessage" />
    <ModalAlertConfirm
      msg="ยืนยันการยกเลิก ?"
      :text="modalMessage"
      btnConfirm="ยืนยัน"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="isModalAlertConfirm"
      @confirm="handleCancel"
    />
  </div>
</template>

<script>
import * as moment from "moment/moment";
import axios from "axios";

import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";

const STATUS = {
  UNASSIGNED: 0,
  ASSIGNED: 1,
  USED: 2,
  EXPIRED: 3,
  CANCELLED: 4,
};

export default {
  props: {
    couponId: {
      type: Number,
      required: false,
    },
    couponList: {
      type: Array,
      required: false,
    },
    prefixCode: {
      type: String,
      required: false,
    }
  },
  components: {
    ModalLoading,
    ModalAlert,
    ModalAlertConfirm,
  },
  data() {
    return {
      showModal: false,
      fields: [
        {
          key: "code",
          label: "โค้ด",
        },
        {
          key: "customer",
          label: "ลูกค้า",
        },
        {
          key: "status",
          label: "สถานะ",
        },
        {
          key: "createDate",
          label: "วันที่สร้าง",
        },
        {
          key: "action",
          label: "",
        },
      ],
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      items: [],
      rows: 0,
      isBusy: false,
      filter: {
        pageNo: 1,
        perPage: 5,
      },
      modalMessage: "",
      couponCode: "",
      prefix: "",
    };
  },
  methods: {
    show() {
      this.showModal = true;
    },
    hide() {
      this.showModal = false;
    },
    resloveStatusColor(status) {
      switch (status) {
        case STATUS.UNASSIGNED:
          return "";
        case STATUS.ASSIGNED:
          return "";
        case STATUS.USED:
          return "text-success";
        case STATUS.EXPIRED:
          return "text-secondary";
        case STATUS.CANCELLED:
          return "text-danger";
        default:
          return "";
      }
    },
    resloveStatusText(status) {
      switch (status) {
        case STATUS.UNASSIGNED:
          return "ยังไม่ได้รับลูกค้า";
        case STATUS.ASSIGNED:
          return "รับลูกค้าแล้ว";
        case STATUS.USED:
          return "ใช้แล้ว";
        case STATUS.EXPIRED:
          return "หมดอายุ";
        case STATUS.CANCELLED:
          return "ยกเลิก";
        default:
          return "-";
      }
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      if (this.couponId) this.getList();
    },
    hanndleChangePerpage(value) {
      this.filter.pageNo = 1;
      this.filter.perPage = value;
    },
    getList: async function () {
      this.isBusy = true;
      let resData = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/Coupon/${this.couponId}`,
        null,
        this.$headers,
        this.filter
      );

      if (resData.result == 1) {
        this.items = resData.detail.userCoupons.map((item) => {
          return {
            id: item.id,
            code: item.couponCode,
            customer: item.firstName
              ? `${item.firstName} ${item.lastName ?? ""}`
              : "-",
            status: item.status,
            createDate: item.createdTime,
          };
        });
        this.prefix = resData.detail.prefix;
        this.rows = resData.detail.userCoupons.length;
      }
      this.isBusy = false;
    },
    exportFile: async function () {
      this.$refs.modalLoading.show();
      let filter = {
        ...this.filter,
        id: this.couponId,
      };

      await axios({
        url: `${this.$baseUrl}/api/Coupon/Exportexcel`,
        method: "post",
        headers: this.$headers,
        responseType: "blob",
        data: filter,
      })
        .then(async (response) => {
          this.$refs.modalLoading.hide();
          if (response.data.type == "application/json") {
            const responseData = await response?.data?.text();
            const responseJson = JSON.parse(responseData);

            this.modalMessage = responseJson.message;
            this.$refs.modalAlert.show();
            setTimeout(() => {
              this.$refs.modalAlert.hide();
            }, 3000);
          } else {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            var dateExcel = moment().format("DDMMYYYYhhmmss");

            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              `Coupon-List-` + dateExcel + `.xlsx`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    exportExcel: async function () {
      this.$refs.modalLoading.show();
      let filter = {
        ...this.filter,
        id: this.couponId,
      };

      await axios({
        url: `${this.$baseUrl}/api/Coupon/UserCouponsExportexcel`,
        method: "post",
        headers: this.$headers,
        responseType: "blob",
        data: filter,
      })
        .then(async (response) => {
          this.$refs.modalLoading.hide();
          if (response.data.type == "application/json") {
            const responseData = await response?.data?.text();
            const responseJson = JSON.parse(responseData);

            this.modalMessage = responseJson.message;
            this.$refs.modalAlert.show();
            setTimeout(() => {
              this.$refs.modalAlert.hide();
            }, 3000);
          } else {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            var dateExcel = moment().format("DDMMYYYYhhmmss");

            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              `Coupon-List-` + dateExcel + `.xlsx`
            );
            document.body.appendChild(fileLink);
            fileLink.click();
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    handleCancel: async function () {
      this.$refs.isModalAlertConfirm.hide();
      this.$refs.modalLoading.show();
      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/Coupon/CencelUserCoupon`,
        null,
        this.$headers,
        {
          couponCode: this.couponCode,
        }
      );

      this.$refs.modalLoading.hide();
      if (resData.result == 1) {
        this.modalMessage = "ยกเลิกสำเร็จ";
        this.$refs.modalAlert.show();

        setTimeout(() => {
          this.$refs.modalAlert.hide();
          this.getList();
        }, 2000);
      }
    },
    openModalCancel: async function (couponCode) {
      this.couponCode = couponCode;
      this.modalMessage = `คุณต้องการยกเลิก ${couponCode} ใช่หรือไม่?`;
      this.$refs.isModalAlertConfirm.show();
    },
  },
  // created: async function () {
  //   await this.getList();
  // },
  watch: {
    showModal: function () {
      if (this.showModal && this.couponId) {
        this.getList();
      } else {
        this.items = this.couponList.map((item) => {
          return {
            code: item,
            customer: "-",
          };
        });
        this.prefix = this.prefixCode
        this.filter.pageNo = 1;
        this.filter.perPage = 5;
        this.rows = this.couponList.length;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: #2eb85c !important;
}

.text-danger {
  color: #e55353 !important;
}

// .text-warning {
//   color: #f9b115 !important;
// }

.prefix {
  font-size: 20px;
}

::v-deep(.table) {
 thead th:first-child {
  width: 300px;
 }
}
</style>
